const SOURCEFORM_TMBD = 'tmBd'
const ACTIONTYPE_DM = 65 
const SOURCEFORM_DM = 'DM'
const TMBD_PADDINGTOP = '15px'
const URL_DM_DETAIL = "https://test.wenyu6.com/sdyxweb/"
const SET_ORDER_TYPE_DM = '100DM' 
export {
  // eslint-disable-next-line import/prefer-default-export
  URL_DM_DETAIL, // 大麦url
  ACTIONTYPE_DM, // 大麦 actionType 65
  SOURCEFORM_TMBD, // 团建小程序
  SOURCEFORM_DM, // 大麦
  TMBD_PADDINGTOP, // 距离头部
  SET_ORDER_TYPE_DM, // 设置大麦 store类型

}